import ProductSlider from './ProductSlider'

export default ProductSlider
